var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$currentUser.role != "admin"
      ? _c("div", { staticClass: "main-content bg-white" }, [
          _c("span", { staticClass: "alert-danger" }, [
            _vm._v("У вас нет доступа к этой странице.")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$currentUser.role == "admin"
      ? _c("div", { staticClass: "main-content bg-white" }, [
          _c("div", { staticClass: "page-header" }, [
            _c("h3", { staticClass: "page-title" }, [
              _vm._v("Лог #" + _vm._s(_vm.$route.params.id))
            ]),
            _vm._v(" "),
            _c("h4", [
              _vm._v(
                _vm._s(_vm.log.parsedSubjectType) +
                  " ID: " +
                  _vm._s(_vm.log.subject_id)
              )
            ])
          ]),
          _vm._v(" "),
          _vm.log.description == "deleted"
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col lg-12" }, [
                  _c("div", { staticClass: "mb-4" }, [
                    _vm._v(
                      "Объект удалён пользователем " +
                        _vm._s(_vm.log.userName) +
                        " " +
                        _vm._s(_vm.log.created_at)
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.log.description == "updated"
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-12" }, [
                  _c("div", { staticClass: "mb-4" }, [
                    _vm._v(
                      "Объект обновлён пользователем " +
                        _vm._s(_vm.log.userName) +
                        " " +
                        _vm._s(_vm.log.created_at)
                    )
                  ]),
                  _vm._v(" "),
                  _vm.log.changesParsed.length > 0
                    ? _c("div", [
                        !_vm.isMobile
                          ? _c(
                              "div",
                              [
                                _c("b-table", {
                                  attrs: {
                                    hover: "",
                                    responsive: "",
                                    bordered: "",
                                    small: "",
                                    items: _vm.log.changesParsed,
                                    fields: _vm.fields
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isMobile
                          ? _c(
                              "div",
                              [
                                _c("b-table", {
                                  attrs: {
                                    hover: "",
                                    responsive: "",
                                    bordered: "",
                                    stacked: "",
                                    small: "",
                                    items: _vm.log.changesParsed,
                                    fields: _vm.fields
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.log.changesParsed.length == 0
                    ? _c("div", [_vm._v("Объект сохранён без изменений")])
                    : _vm._e()
                ])
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7fe63d8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7fe63d8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/LogView.vue
// module id = 1038
// module chunks = 0